import { getLanguageLevelText, getSuggestionLengthText, getToneText, stripHTML } from 'utils/helper';

export const getPreferenceInstructions = (value) => stripHTML(value || '').trim();

export const getFeedbackStructureLabel = (structure, t) =>
    ({
        rubric: t('feedback-section.rubric-based-feedback', 'Rubric-Based Feedback'),
        system: t('feedback-section.system-based-feedback', 'General & Detailed Feedback'),
        templated: t('feedback-section.templated-feedback', 'Smart Feedback Templates'),
        custom: t('feedback-section.custom-feedback', 'Custom Feedback'),
    })[structure];

export const getFeedbackSummaryItems = (settings, additionalInstructions, t) => {
    if (settings.structure === 'custom') {
        return [
            {
                id: 'custom-instructions',
                label: t('feedback-section.settings.instructions-for-ai', 'Instructions for the AI'),
                value: getPreferenceInstructions(settings.customInstructions),
            },
        ];
    }

    return [
        {
            id: 'suggestion-length',
            label: t('feedback-section.settings.suggestion-length', 'Length of Each Suggestion'),
            value: getSuggestionLengthText(settings.suggestionLength, t),
        },
        {
            id: 'language-level',
            label: t('feedback-settings.language-level.title', 'Language Level'),
            value: getLanguageLevelText(settings.languageLevel, t),
        },
        {
            id: 'feedback-tone',
            label: t('feedback-settings.tone.feedback-title', 'Feedback Tone'),
            value: getToneText(settings.tone, t),
        },
        {
            id: 'additional-instructions',
            label: t('settings.additional-instructions-ai', 'Additional Instructions for AI'),
            value: additionalInstructions,
        },
    ];
};

export const getInlineCommentsSummaryItems = (settings, additionalInstructions, t) => [
    {
        id: 'max-comments-per-page',
        label: t('assignment:inline-comments-section.settings.max-comments', 'Maximum Comments per Page'),
        value: settings.maxCommentsPerPage,
    },
    {
        id: 'comment-length',
        label: t('assignment:inline-comments-section.settings.comment-length', 'Length of Each Comment'),
        value: getSuggestionLengthText(settings.commentLength, t),
    },
    {
        id: 'language-level',
        label: t('assignment:feedback-settings.language-level.title', 'Language Level'),
        value: getLanguageLevelText(settings.languageLevel, t),
    },
    {
        id: 'comment-tone',
        label: t('assignment:feedback-settings.tone.feedback-title', 'Feedback Tone'),
        value: getToneText(settings.tone, t),
    },
    {
        id: 'additional-instructions',
        label: t('assignment:settings.additional-instructions-ai', 'Additional Instructions for AI'),
        value: additionalInstructions,
    },
];
